import React from 'react';

export default class Classification extends React.Component {
    render() {
        const prctg = this.props.prctg;
        let title, msg;

        if (prctg >= 75 && prctg <= 100) {
            title = "Zona de Excelência";
            msg = "Parabéns! Continue com o bom trabalho para manter a sua nota."
        } else if (prctg >= 50 && prctg < 75) {
            title = "Zona de Qualidade";
            msg = " Parabéns, seus clientes estão satisfeitos, mas é possível identificar melhorias.";
        } else if (prctg >= 0 && prctg < 50) {
            title = "Zona de Aperfeiçoamento";
            msg = "Muitos cliente estão insatisfeitos, essa é uma zona de alerta, reformule seus processos e estratégias."
        } else if (prctg >= -100 && prctg < 0) {
            title = "Zona Crítica";
            msg = "Atenção! muitos clientes estão insatisfeitos, reúna sua equipe e busque soluções rápidas."
        }

        return(
            <div id="hi-score">
                <div className="hi-content-box">
                    <span className="hi-index-box nps">NPS</span>
                    <h3>{Math.floor(prctg)}</h3>
                </div>
                <div className="hi-content-box">
                    <span className="hi-index-box fifth">5</span>
                    <h3>Veja a Zona de Classificação da sua empresa:</h3>
                    <span className="hi-nps-subtitle">{title}</span>
                    <p>{msg}</p>
                </div>
            </div>
        );
    }
}